import {
  downloadMultipleFiles,
  dropzonesUploadFiles,
  handleAddAnotherProperty,
  handleDisplayFormDetails,
  setAutocompleteOnAddresses,
  sidebarNavDisplay,
} from './application';
import {
  addressInput,
  bindDobInputs,
  displayErrorMessage,
  saveApplication as saveGeneralApplication,
} from './common';
import { APPLICATION_STOCK_FINANCE } from './constants';
import { generateRequiredRule, STOCK_FINANCE_BUSINESS_RULES, UPLOAD_DOCUMENT_RULES } from './rules';
import { validate } from './validate';

window.sfDocumentReady(['route-application-stock-finance-edit'], () => {
  handleSaveApplication();
  runReview();
  handleDisplayFormDetails();
  downloadMultipleFiles();
  dropzonesUploadFiles();
  runReviewPageValidation();

  function runReviewPageValidation() {
      $('.edit-stage-link').on('click', function () {
        const section = $(this).attr('href');
        $('.stepwizard-step')
          .children(`a[href="${section}"]`)
          .trigger('click');
      });
  }

  function runReview() {
    startReview();
    $('.stepwizard-step.review')
      .children('a')
      .on('click', async () => {
        startReview();
      });
  }

  async function startReview() {
    const applicationId = $('.application_id').val();
    if (!applicationId) return false;
    await window.httpGet(`/stock-finance/review/${applicationId}`, null, {
      success(response) {
        if (!response.data) {
          return;
        }
        const data = response.data;
        checkValidationReview(data);
        if (data.application.privacy_consent_type) {
          $('#consent-form-container').hide();
        }
      },
      error(response, status, error) {
        $('.submitStockFinanceApplication').prop('disabled', true);
        if (ajaxErrorHandler(response.status)) {
          return;
        }
        notifyBox(
          'Error',
          'Please check that all steps of the application are complete before reviewing the application.',
          'error',
        );
      },
    });
  }

  function checkValidationReview(data) {
    const imgComplete = '/images/icons/check-circle-1.svg';
    const imgIncomplete = '/images/icons/alert-circle.svg';
    let completeAll = true;
    $.each(data.validation, (key, value) => {
      // Complete/incomplete with icon indicators
      if (value.status === 'success') {
        $(`#${key}`).find('.status').html('Complete');
        $(`#${key}`)
          .find('.review-image .image')
          .html(`<img src="${imgComplete}" class="image" height="20">`);
        switch (key) {
          case 'resStage_basic':
            renderDescriptionBasicStage(key, data.application);
            break;
          case 'resStage_business':
            renderDescriptionBusiness(key, data.application);
            break;
          case 'resStage_individual1':
            renderDescriptionIndividualStage(
              key,
              data.application.applicants[0],
            );
            break;
          case 'resStage_individual2':
            renderDescriptionIndividualStage(
              key,
              data.application.applicants[1],
            );
            break;

          default:
            break;
        }
        $(`#${key}`).find('.edit-stage-link').html('Edit');
        $(`#${key}`)
          .find('.edit-stage-link')
          .removeClass('button btn btn-submit');
      } else {
        $(`#${key}`).find('.status').html('Incomplete');
        $(`#${key}`)
          .find('.review-image .image')
          .html(`<img src="${imgIncomplete}" class="image" height="20">`);
        $(`#${key}`).find('.description-stage').html(value.msg);
        $(`#${key}`).find('.edit-stage-link').addClass('button btn btn-submit');
        $(`#${key}`).find('.edit-stage-link').html('Complete this step');
        $('#resStage_review').find('.description-stage').html(`
                <div class="mb-4">To proceed will need to sign a privacy consent.</div>
                <div>
                This will allow Solaris Finance to handle their information for the purposes of assessing
                a loan application. Further information will be provided on the document.
                </div>
            `);
        if (key !== 'resStage_review') {
          completeAll = false;
        }
      }
    });
    if (!completeAll) {
      $('#resStage_review')
        .find('.description-stage')
        .html('Please complete all the above steps before submit.');
      $('.submitStockFinanceApplication').prop('disabled', true);
    } else {
      $('.submitStockFinanceApplication').prop('disabled', false);
      if (data.application.privacy_consent_verified === 1) {
        $('#stepwizard-review').addClass('step-complete');
      }
    }
    $('#resStage_review').hide();
  }

  function renderDescriptionBasicStage(element, application) {
    $(`#${element}`)
      .find('.description-stage')
      .html(
        `<div class="row sf-mb-3">
          <div class="col-md-4">Borrowing Amount</div>
          <b class="col-md-6">$ ${application.system_cost}</b>
      </div>`,
      );
  }

  function renderDescriptionBusiness(element, application) {
    const content = `
    <div class="row sf-mb-3">
      <div class="col-md-12">${application.business_name}, ${application.business_location}</div>
    </div>`;
    $(`#${element}`).find('.description-stage').html(content);
  }

  function renderDescriptionIndividualStage(element, applicant) {
    const fullName = `${applicant.first_name.trim()} ${applicant.middle_name.trim()} ${applicant.last_name.trim()}`;
    let content = `<div class="row sf-mb-3">
        <div class="col-md-4">Name</div>
        <b class="col-md-6">${fullName}</b>
    </div>
    <div class="row sf-mb-3">
        <div class="col-md-4">Driver's Licence</div>
        <b class="col-md-6">${applicant.driving_licence}</b>
    </div>
    <div class="row sf-mb-3">
        <div class="col-md-4">Driver's Licence card</div>
        <b class="col-md-6">${applicant.driving_licence_card}</b>
    </div>
   
    <div class="row sf-mb-3">
        <div class="col-md-4">Phone Number</div>
        <b class="col-md-6">${JSON.parse(applicant.mobile)[0].work_phone}</b>
    </div>
    <div class="row sf-mb-3">
        <div class="col-md-4">Email Address</div>
        <b class="col-md-6">${applicant.email}</b>
    </div>
    
    <div class="row sf-mb-3">
        <div class="col-md-4">Address</div>
        <b class="col-md-6">${applicant.location}</b>
    </div>
   `;

    $(`#${element}`).find('.description-stage').html(content);
  }

  function handleSaveApplication() {
    $(document).on('click', '.btn-save-stock-finance', function () {
      const $form = $(this).closest('form');
      const stage = $form.find('input[name=stage]').val();

      const saveHandlers = {
        business: saveSupplierBusiness,
        uploads: saveUploadDocument,
      };

      const saveHandler = saveHandlers[stage];
      if (saveHandler) {
        saveHandler($(this), $form);
      }
    });
  }

  function saveUploadDocument($button, $form) {
    const dataForm = $form.serializeArray();
    const rules = handleUploadDocumentRules(dataForm, $form);

    const isValid = validate(dataForm, $form, rules);
    if (!isValid) return false;

    saveApplication($button, dataForm).then((response) => {});
  }

  function handleUploadDocumentRules(dataForm, $form) {
    const rules = { ...UPLOAD_DOCUMENT_RULES };

    $form.find('.panel-body .row fieldset').each(function () {
      const $input = $(this).find('input[name]');
      const nameField = $input.attr('name');
      if (!nameField) return;

      const indexMatch = nameField.match(/\[(\d+)\]/);
      if (!indexMatch) return;

      const indexName = indexMatch[1];
      const statusField = `application_documents[${indexName}][status]`;
      const fileNameField = `application_documents[${indexName}][file_name]`;

      const isStatusApproved = dataForm.some(
        (item) => item.name === statusField && item.value === '1',
      );

      rules[fileNameField] = isStatusApproved ? generateRequiredRule() : {};
    });

    return rules;
  }

  function saveSupplierBusiness($button, $form) {
    const rules = STOCK_FINANCE_BUSINESS_RULES;
    if ($('#applicant_type').val() === '4') {
      rules['acn_number'] = {
        required: {
          value: true,
          message: 'Required',
        },
        maxLength: {
          value: 9,
          message: 'ACN must be 9 digits',
        },
        minLength: {
          value: 9,
          message: 'ACN must be 9 digits',
        },
      };
    }
    const dataForm = $form.serializeArray();
    const isValid = validate(dataForm, $form, rules);
    if (!isValid) return;
    saveApplication($button, dataForm).then((res) => {
      const { gst_status_at, applicants_count } = res.data.data.application;
      handleAddOneIndividual(applicants_count, false);
      const [day, month, year] = gst_status_at.split('-');
      const formattedDate = `${year}-${month}-${day}`;
      $('#gst_status_at').val(formattedDate);
    });
  }

  function handleAddOneIndividual(applicantsCount, deepClone) {
    if (parseInt(applicantsCount) === 2) {
      if (!$(`#individual-content-2`).length) {
        const $elementCloned = $(`#individual-content-1`).clone(deepClone);
        const $navItemCloned = $(`.stepwizard-step#stepwizard-individual1`)
          .first()
          .clone(true);
        const $reviewItemCloned = $(
          `.review-application #resStage_individual1`,
        ).clone(true);
        $elementCloned.find('.ffl-wrapper').floatingFormLabels({
          formElements: 'input, textarea, select',
        });
        $elementCloned.attr('id', `individual-content-2`);
        $elementCloned.attr('data-stage', `individual2`);
        $elementCloned.find('form').attr(`data-individual-index`, '2');
        $elementCloned
          .find(
            'input[type=hidden]:not(.application_id, .finance_type, .income_type_value, .no-change-value)',
          )
          .val('');
        $elementCloned
          .find('input[type=hidden][name=stage]')
          .val(`individual2`);
        $elementCloned.find('input[type=radio]').prop('checked', false);
        $elementCloned.find('.work_phone_type').prop('checked', true);
        $elementCloned.find('option:selected').prop('selected', false);
        $elementCloned.find('input[type=text]').val('');
        $elementCloned.find('input[type=contact_email]').val('');
        $elementCloned.find('input[type=number]').val('');
        $elementCloned.find('#application_type').val(APPLICATION_STOCK_FINANCE);
        $elementCloned
          .find(
            'input[type=radio], input[type=checkbox], input[type=text], input[type=contact_email]',
          )
          .each(function () {
            const oldId = $(this).attr('id');
            $(this).attr('id', `individual2-${oldId}`);
            $(this).siblings('label').attr('for', `individual2-${oldId}`);
          });
        $elementCloned.find('.container_detail').hide();
        $elementCloned.hide();
        $elementCloned.insertAfter(`#individual-content-1`);
        //clone nav step
        $navItemCloned.removeClass('success step-complete');
        $navItemCloned.attr('id', `stepwizard-individual2`);
        $navItemCloned.find('a').attr('href', `#individual2`);
        $navItemCloned.find('h6').html(`individual 2`);
        $(`.stepwizard-step#stepwizard-individual1 h6`).html(`individual 1`);
        $navItemCloned.insertAfter(`.stepwizard-step#stepwizard-individual1`);
        //clone review
        $reviewItemCloned.attr('id', `resStage_individual2`);
        $reviewItemCloned.find('.review-title h4').html(`individual 2`);
        $reviewItemCloned
          .find('a.edit-stage-link')
          .attr('href', `#individual2`);
        $reviewItemCloned.insertAfter(
          `.review-application #resStage_individual1`,
        );
      }
    } else if (
      parseInt(applicantsCount) === 1 &&
      $(`#individual-content-2`).length
    ) {
      $(`#individual-content-2`).remove();
      $(`.stepwizard-step#stepwizard-individual2`).remove();
      $(`.review-application #resStage_individual2`).remove();
      $(`.stepwizard-step#stepwizard-individual1 h6`).html(`individual`);
    }
    handleReStepWizard();
    $('.setup-panel div a').on('click', function (e) {
      sidebarNavDisplay(
        e,
        $(this),
        $('.setup-panel div a'),
        $('.setup-content'),
      );
    });
    setAutocompleteOnAddresses();
    handleAddAnotherProperty();
    addressInput();
    bindDobInputs();
  }

  function handleReStepWizard() {
    $('.stepwizard-step').each(function (index) {
      $(this)
        .find('a')
        .html(index + 1);
    });
  }

  const saveApplication = ($button, dataForm = null) => {
    if ($('.application_id').val()) {
      const $curStep = $button.closest('.setup-content');
      const curStepBtn = $curStep.attr('data-stage');
      const navItem = $(`.setup-panel div a[href="#${curStepBtn}"]`).parent();
      const nextStepWizard = navItem.next().children('a');
      return new Promise((resolve, reject) => {
        saveGeneralApplication(dataForm, {
          success(data) {
            $('.js-display-errors').html('');
            if (data.status === 'success') {
              navItem.addClass('step-complete');
              if ($button.hasClass('continueAfterSaving')) {
                nextStepWizard.trigger('click');
              } else {
                window.location.href = '/';
              }
              $('html, body').animate(
                {
                  scrollTop: 0,
                },
                100,
              );
            }
            $('html, body').animate(
              {
                scrollTop: 0,
              },
              100,
            );
            resolve(data);
          },
          error(response, status, error) {
            if (response.responseJSON && response.responseJSON.errors) {
              const errors = response.responseJSON.errors;
              displayErrorMessage($button, errors, response.status);
            } else {
              notifyBox(
                'Error',
                'An unexpected error occurred. Please try again',
                'error',
              );
            }
            if (ajaxErrorHandler(response.status)) {
              return;
            }
            navItem.removeClass('step-complete');
          },
        });
      });
    } else {
      notifyBox(
        'Unable to save',
        'Please fill basic information first',
        'error',
      );
    }
  };
});


window.sfDocumentReady(['route-application-stock-finance-view'], async () => {
  function showChosenDropzoneContainer(element) {
    const containerId = element.id;
    const containerElement = $(`.js-dz-container-${containerId}`);
    containerElement.removeClass('hidden');
    containerElement.show();
  }

  $('.js-show-condition-container').click(function (event) {
    event.preventDefault();

    $('.js-condition-empty-state').hide();

    $('.js-dz-element').hide();

    showChosenDropzoneContainer(this);
  });

  $('.js-submit-form-on-change').change(function () {
    $(this).parent('form').submit();
  });

  $('.js-confirm-delete').click(function () {
    return confirm('Are you sure you want to delete this application?');
  });

  $('.js-confirm-send-docs').click(function () {
    return confirm(
      'Are you sure you want to send documents to all applicants?',
    );
  });

  $('.js-confirm-send-esign-docs').click(function () {
    return confirm(
      'Are you sure you want to decline signed agreement and resend to all applicants?',
    );
  });
});
